<template>
    <div>
        <signup-form
            :loading="loading"
            @submited="register"
        ></signup-form>
    </div>
</template>
<script>
export default {
    layout: "auth",
    auth: "guest",
    validate(context) {
        return context.system.systemSettings.signup_from_customers_permission;
    },
    data() {
        return {
            loading: false,
            username_type: this.$system.systemSettings.username_type,
        };
    },
    methods: {
        async register(data) {
            this.loading = true;
            let res = await this.$register(data);
            if (res && res.status == "OK") {
                this.$router.push({path: '/login', query: {[this.username_type]: data[this.username_type]} });
                this.$toast.success(res.message);
            }
            this.loading = false;
        }
    },
};
</script>
